module.exports = __webpack_public_path__ + "img/coming-soon-chart.aa87a2b.jpg";